import { render, staticRenderFns } from "./UserFormFields.vue?vue&type=template&id=b7a4cc50&scoped=true&"
import script from "./UserFormFields.vue?vue&type=script&lang=js&"
export * from "./UserFormFields.vue?vue&type=script&lang=js&"
import style0 from "./UserFormFields.vue?vue&type=style&index=0&id=b7a4cc50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a4cc50",
  null
  
)

export default component.exports